async function getAppVersion() {
  return `7.99.99`;
}

export { getAppVersion };
